import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

const AuditsApiService = class AuditsApiService extends APIServiceBase {
    constructor(endpointControllerName) {
        super(endpointControllerName)
    }

    indexPage(data) {
        return this.post('IndexPage', data)
    }
}

export class ProjectAuditsApiService extends AuditsApiService {
    constructor() {
        super('ProjectAudit')
    }
}

export class TWSProjectAuditsApiService extends AuditsApiService {
    constructor() {
        super('TWSProjectAudit')
    }
}

export class CustomerAuditsApiService extends AuditsApiService {
    constructor() {
        super('CustomerAudit')
    }
}


registerAPIService(ProjectAuditsApiService)
registerAPIService(CustomerAuditsApiService)
registerAPIService(TWSProjectAuditsApiService)